import { render, staticRenderFns } from "./SubHeaderGrey.vue?vue&type=template&id=bc0040b4&"
import script from "./SubHeaderGrey.vue?vue&type=script&lang=js&"
export * from "./SubHeaderGrey.vue?vue&type=script&lang=js&"
import style0 from "./SubHeaderGrey.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports